import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../../utils/axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Initialize Auth State
// src/components/auth/AuthContext.jsx
useEffect(() => {
  const verifySession = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const res = await api.get('/auth/me'); // Using your axios instance
        setUser(res.data.user);
      } catch (err) {
        // If token is expired or invalid
        localStorage.removeItem('token');
        setUser(null);
      }
    }
    setLoading(false);
  };
  verifySession();
}, []);

  const login = async (email, password) => {
    try {
      // Connect to your Node.js backend
      const response = await api.post('/auth/login', { email, password });
      
      const { token, user: userData } = response.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
      
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Connection failed' 
      };
    }
  };


  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };


  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);